import { updatesData } from '@/mocks/homeData';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">追剧快讯</h2>
          <p className="text-sm text-foreground-500 mt-2">最新电视剧上线与更新动态，第一时间掌握追剧风向</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-px bg-background-300 md:-translate-x-px"></div>

          <div className="space-y-8">
            {updatesData.map((item, idx) => {
              const isLeft = idx % 2 === 0;
              return (
                <div
                  key={idx}
                  className={`relative flex flex-col md:flex-row items-start gap-4 md:gap-0 ${
                    isLeft ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className="absolute left-0 md:left-1/2 w-[39px] flex justify-center md:-translate-x-1/2">
                    <div className="w-[9px] h-[9px] rounded-full bg-primary-500 ring-4 ring-background-50 mt-1.5"></div>
                  </div>

                  <div className={`pl-14 md:pl-0 md:w-1/2 ${isLeft ? 'md:pr-12 md:text-right' : 'md:pl-12'}`}>
                    <div className="bg-background-100 rounded-xl p-5 md:p-6">
                      <div className="flex items-center gap-2 mb-2 flex-wrap">
                        <span className="text-xs text-foreground-400">{item.date}</span>
                        <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs rounded-full">
                          {item.tag}
                        </span>
                      </div>
                      <h3 className="text-base md:text-lg font-semibold text-foreground-900 leading-snug">
                        {item.title}
                      </h3>
                      <p className="text-sm text-foreground-500 mt-2 leading-relaxed">{item.summary}</p>
                    </div>
                  </div>
                  <div className="hidden md:block md:w-1/2"></div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}